import React from "react";
import _ from "lodash";
import { withTranslation } from "react-i18next";
import DateInput from "../../../parts/inputs/date-input";
import Modal from "../../../parts/modal";
import { RillContext } from "../../../rill/RillReact/share/base";

const {
  COMPETITIONS: { LEVELS, FEDERATIONS, CATEGORIES, TYPES },
} = require("../../../constants");

class View extends React.Component {
  constructor(props, ctx) {
    super(props, ctx);
    const { locals } = this.props;
    const { editCompetition } = locals;
    this.state = { type: _.get(editCompetition, "type") };
    this.handleTypeChange = this.handleTypeChange.bind(this);
  }

  componentWillUpdate() {
    const type = _.get(this.props, "locals.editCompetition.type");
    if (this.state.type !== type) this.setState({ type });
  }

  handleTypeChange({ target: { value } }) {
    if (this.state.type !== value) this.setState({ type: value });
  }

  render() {
    const { t, locals } = this.props;
    const { editCompetition, units, momentTZ } = locals;
    const total = _.get(editCompetition, "total", 0);
    const wilks = _.get(editCompetition, "wilks", "");
    const isBenchOnly = _.includes(this.state.type, "Bench Only");
    const isSaved = _.has(editCompetition, "_id");
    return (
      <form
        action={`/actions/competition/save/${_.get(
          editCompetition,
          "_id",
          ""
        )}`}
        className="Edit-Competition"
        method="POST"
        data-noreset
      >
        <Modal width="470px">
          <input type="hidden" name="tense" value="future" />
          <input type="hidden" name="total" value={total} />
          <h2>{t("editUpcomingCompetition.title")}</h2>
          <div className="Main">
            <div className="frame wide alt">
              <div className="columns">
                <div className="column" data-col="1/2">
                  <div className="label">{t("editUpcomingCompetition.competitionDate")}</div>
                  <DateInput
                    required
                    name="date"
                    defaultValue={_.get(editCompetition, "date", "")}
                    onChange={this.handleDateChange}
                    min={momentTZ().startOf("day")}
                  />
                </div>

                <div className="3/4"></div>

                <div className="column" data-col="1/1">
                  <div className="label">{t("editUpcomingCompetition.competitionName")}</div>
                  <input
                    className="text-input"
                    type="text"
                    name="name"
                    defaultValue={_.get(editCompetition, "name", "")}
                    required
                  />
                </div>

                <div className="column" data-col="1/1">
                  <div className="label">{t("editUpcomingCompetition.federation")}</div>
                  <select
                    required
                    name="federation"
                    className="select-input"
                    defaultValue={_.get(editCompetition, "federation", "")}
                  >
                    <option disabled hidden value="">
                      {t("editUpcomingCompetition.federation")}
                    </option>
                    {_.map(FEDERATIONS, (federation) => {
                      return (
                        <option key={federation} value={federation}>
                          {federation}
                        </option>
                      );
                    })}
                  </select>
                </div>

                <div className="column" data-col="1/1">
                  <div className="label">{t("editUpcomingCompetition.levelOfCompetition")}</div>
                  <select
                    name="level"
                    className="select-input"
                    defaultValue={_.get(editCompetition, "level", "")}
                  >
                    <option disabled hidden value="">
                      {t("editUpcomingCompetition.level")}
                    </option>
                    {_.map(LEVELS, (level) => {
                      return (
                        <option key={level} value={level}>
                          {_.capitalize(level)}
                        </option>
                      );
                    })}
                  </select>
                </div>

                <div className="column" data-col="1/1">
                  <div className="label">{t("editUpcomingCompetition.category")}</div>
                  <select
                    required
                    name="category"
                    className="select-input"
                    defaultValue={_.get(editCompetition, "category", "")}
                  >
                    <option disabled hidden value="">
                      {t("editUpcomingCompetition.category")}
                    </option>
                    {_.map(CATEGORIES, (category) => {
                      return (
                        <option key={category} value={category}>
                          {category}
                        </option>
                      );
                    })}
                  </select>
                </div>

                <div className="column" data-col="1/1">
                  <div className="label">{t("editUpcomingCompetition.competitionType")}</div>
                  <select
                    required
                    name="type"
                    onChange={this.handleTypeChange}
                    className="select-input"
                    defaultValue={_.get(editCompetition, "type", "")}
                  >
                    <option disabled hidden value="">
                      {t("editUpcomingCompetition.type")}
                    </option>
                    {_.map(TYPES, (type) => {
                      return (
                        <option key={type} value={type}>
                          {type}
                        </option>
                      );
                    })}
                  </select>
                </div>

                <div className="column" data-col="1/2">
                  <div className="label">{t("editUpcomingCompetition.weightClass")}</div>
                  <input
                    required
                    type="text"
                    className="text-input"
                    name="weightClass"
                    placeholder=""
                    defaultValue={_.get(editCompetition, "weightClass", "")}
                  />
                </div>
              </div>
            </div>
            <div className="actions">
              {isSaved ? (
                <a
                  className="button delete"
                  href={`/actions/competition/remove/${_.get(
                    editCompetition,
                    "_id"
                  )}`}
                >
                  {t("editUpcomingCompetition.deleteCompetition")}
                </a>
              ) : (
                <a
                  href={`/actions/competition/cancel/?redirect=${encodeURIComponent(
                    "/dashboard/competitions/?list=upcoming"
                  )}`}
                  className="button alt"
                >
                  {t("common:cancel")}
                </a>
              )}
              <button className="button button-input" type="submit">
                {t("common:save")}
              </button>
            </div>
          </div>
        </Modal>
      </form>
    );
  }
}

View.contextType = RillContext;

export default withTranslation("dashboard")(View);
